import axios from "axios";

export const getGruppiUtenteByIdUsrApi = (idUsr) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/${idUsr}/gruppi/`);
}

export const getGruppiUtenteApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/gruppi/`);
}

export const getGruppiUtenteByIdApi = (idGruppo) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/gruppi/${idGruppo}`);
}

export const getUtentiAssociatiAGruppoApi = (idGruppo) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/gruppi/${idGruppo}/associati/`);
}

export const getPermessiGruppoApi = (idGruppo) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/gruppi/${idGruppo}/permessi/`);
}

export const aggiornaGruppoUtenteApi = (idGruppo, gruppo) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/gruppi/${idGruppo}`, gruppo);
}

export const aggiungiGruppoUtenteApi = (gruppo) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/gruppi/`, gruppo);
}

export const rimuoviUtenteDaGruppoApi = (idUsr, idGruppo) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/${idUsr}/rel-gruppi/${idGruppo}`);
}

export const deleteRelazioneUtenteGruppoApi = (idGruppo, idRel) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/gruppi/${idGruppo}/rel-gruppi/${idRel}`);
}

export const aggiungiRelazioneUtenteGruppoApi = (idUsr, relazione) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/${idUsr}/rel-gruppi/`, relazione)
}

export const aggiungiPermessoGruppoApi = (idGruppo, permessi) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/gruppi/${idGruppo}/permessi/`, permessi)
}

export const deleteGruppoUtenteApi = (idGruppo) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/gruppi/${idGruppo}`);
}

export const getUtentiNonAssociatiApi = (idGruppo) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/gruppi/${idGruppo}/non-associati/`);
}

export const associaUtenteAGruppoApi = (idUsr, rel) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/utente/${idUsr}/rel-gruppi/`, rel);
}